<div class="content" [ngClass]="{'left': !showRight, 'right': showRight}"
  [ngDraggable]="isPdfFile() === true && hasPreview() === true" style="z-index: 10;">
  <ng-container *ngIf="isPdfFile() === true && hasPreview() === true">
    <!-- Close icon -->
    <div class="draggableArea" *ngIf="!loading && images.length !== 0">
      <i class="fa fa-bars menu"></i>
      <span class="title">Drag & Drop Document using this header</span>
      <div class="closePreview" (click)="expandArea()" style="right: 35px;">
        <i class="fa fa-expand expand"></i>
      </div>
      <div class="closePreview" (click)="closePreview()">
        <i class="fa fa-close"></i>
      </div>
    </div>

    <div class="content-wrapper" [ngClass]="{'loading': loading || loadingDup, 'image': !loading && images.length !== 0,
      'small': !loading && images.length !== 0 && size === PreviewSize.SMALL,
      'medium': !loading && images.length !== 0 && size === PreviewSize.MEDIUM,
      'large': !loading && images.length !== 0 && size === PreviewSize.LARGE}">
      <!-- Loader -->
      <loader [loading]="loading || loadingDup"></loader>

      <!-- Image -->
      <div class="item" *ngIf="!loading && images.length !== 0">
        <img *ngFor="let image of images" [src]="image" style="width: 100%; height: 100%" />
      </div>
    </div>
  </ng-container>

  <div class="content-wrapper" *ngIf="isPdfFile() !== true">
    <div class="item message">
      <p class="text-danger">Only PDF files can be previewed. <br/>Please download this document to view.</p>
    </div>
  </div>

  <div class="content-wrapper" *ngIf="isPdfFile() === true && !hasPreview()">
    <div class="item message">
      <p class="text-danger">Only PDF files of 10 pages or less can be previewed.<br/>Please download this document to view.</p>
    </div>
  </div>
</div>
